import { CaretDown } from "@phosphor-icons/react";
import { useState } from "react";
import { Button, PopupSelect, Typography } from "../components";
import Section from "../components/Section";
import { ISelectInput } from "../models";
import Dropdown from "../components/Select/Dropdown";

const ISelectPopup = () => {
	const [state, setState] = useState<any>({});
	const [formSubmitted, setFormSubmitted] = useState(false);
	const handleSelect = (event: ISelectInput | ISelectInput[], name: string) => {
		setState({ ...state, [name]: event });
	};

	const options = [
		{ label: "USD", value: "USD", code: "USD", symbol: "$" },
		{ label: "INR", value: "INR", code: "INR", symbol: "₹" },
		{ label: "EUR", value: "EUR", code: "EUR", symbol: "€" },
		{ label: "GBP", value: "GBP", code: "GBP", symbol: "£" },
		{ label: "JPY", value: "JPY", code: "JPY", symbol: "¥" },
		{ label: "AUD", value: "AUD", code: "AUD", symbol: "A$" },
		{ label: "CAD", value: "CAD", code: "CAD", symbol: "C$" }
	];
	const merchantsList = [
		{
			label: "Kapil Prashad",
			value: "kapil-prashad",
			supportingText: "@kapil",
			badge: "Admin",
			image_hash: "5f5b174c8ab6c732caffd82dfd54e72c50b5c686",
			mime_type: "image/png"
		},
		{ label: "Jane Doe", value: "jane-doe", supportingText: "@jane", badge: "User", disabled: true },
		{ label: "John Smith", value: "john-smith", supportingText: "@smith", badge: "User", src_text: "John Smith" },
		{
			label: "Jagan",
			value: "jagan",
			supportingText: "@jagan",
			badge: "User",
			src: "https://lh3.googleusercontent.com/ogw/AF2bZyiblb3IWMhXzI86zV3P3aEr2qfPacKWrGT_PB1bDxCR=s64-c-mo"
		},
		{ label: "John Doe", value: "john-doe", supportingText: "@john", badge: "User" },
		{ label: "Olivia Rhye", value: "olivia-rhye", supportingText: "@olivia", badge: "Admin" }
	];

	return (
		<Section title={"# Select"}>
			<Typography size="xl">PopupSelect </Typography>
			<div className="d-flex gap3 mb-3 flex-wrap">
				<PopupSelect
					target={
						<Button
							label={"Multi Select"}
							variant={"secondary"}
							iconPosition="right"
							rightIcon={<CaretDown weight="bold" />}
							onClick={() => {}}
						/>
					}
					value={state.multiselect}
					setValue={(event: ISelectInput[]) => handleSelect(event, "multiselect")}
					selectOptions={merchantsList}
					type="icon-leading"
					popupParentClass="mt-1"
					position="bottom-right"
					isMulti={true}
					popupStyle={{ width: "300px" }}
					// isLoading={isPartnerLoading}
				/>
				<PopupSelect
					target={
						<Button
							label={"Select - bottom-right"}
							variant={"secondary"}
							iconPosition="right"
							rightIcon={<CaretDown weight="bold" />}
							onClick={() => {}}
						/>
					}
					value={state.value}
					setValue={(event: ISelectInput) => handleSelect(event, "value")}
					selectOptions={options}
					popupParentClass="mt-1"
					position="bottom-right"
					// isLoading={isPartnerLoading}
				/>
				<PopupSelect
					target={
						<Button
							label={"Select - bottom-left"}
							variant={"secondary"}
							iconPosition="right"
							rightIcon={<CaretDown weight="bold" />}
							onClick={() => {}}
						/>
					}
					value={state.value}
					setValue={(event: ISelectInput) => handleSelect(event, "value")}
					selectOptions={options}
					popupParentClass="mt-1"
					position="bottom-left"
					// isLoading={isPartnerLoading}
				/>
				<PopupSelect
					target={
						<Button
							label={"Select - bottom"}
							variant={"secondary"}
							iconPosition="right"
							rightIcon={<CaretDown weight="bold" />}
							onClick={() => {}}
						/>
					}
					value={state.value}
					setValue={(event: ISelectInput) => handleSelect(event, "value")}
					selectOptions={options}
					popupParentClass="mt-1"
					position="bottom"
					// isLoading={isPartnerLoading}
				/>

				<PopupSelect
					target={
						<Button
							label={"Select - top"}
							variant={"secondary"}
							iconPosition="right"
							rightIcon={<CaretDown weight="bold" />}
							onClick={() => {}}
						/>
					}
					value={state.value}
					setValue={(event: ISelectInput) => handleSelect(event, "value")}
					selectOptions={options}
					popupParentClass="mt-1"
					position="top"
				/>
				<PopupSelect
					target={
						<Button
							label={state.value9?.label || "Select..."}
							variant={"secondary"}
							iconPosition="right"
							rightIcon={<CaretDown weight="bold" />}
							onClick={() => {}}
							className="w-300 d-flex justify-content-between"
						/>
					}
					value={state.value9}
					setValue={(event: ISelectInput) => handleSelect(event, "value9")}
					selectOptions={merchantsList}
					popupParentClass="mt-1"
					position="inherit"
					label="Select merchant"
					// isLoading={true}
				/>
				<div className="w-300">
					<PopupSelect
						target={
							<Button
								label={state.value10?.map((i: ISelectInput) => i.label)?.join(", ") || "Select..."}
								variant={"secondary"}
								iconPosition="right"
								rightIcon={<CaretDown weight="bold" />}
								onClick={() => {}}
								className="w-100 d-flex justify-content-between"
							/>
						}
						value={state.value10}
						setValue={(event: ISelectInput) => handleSelect(event, "value10")}
						selectOptions={merchantsList}
						popupParentClass="mt-1"
						position="inherit"
						label="Multi Select merchant"
						isMulti={true}
						dropdownClass="w-100"
						// isLoading={true}
					/>
				</div>
			</div>
			<div className="divider"></div>
			<Typography size="xl">Dropdowns </Typography>
			<div className="d-flex gap3 mb-3 flex-wrap">
				<Dropdown
					id="select-currency"
					label="Select Currency"
					options={options}
					onChange={(e: ISelectInput) => handleSelect(e, "value1")}
					value={state.value1}
					hintText="This is hint text."
					errorMessage=""
					required={true}
					tooltip={"This is a tooltip."}
				/>
				<Dropdown
					id="select-currency"
					label="Clearable Select Currency"
					options={options}
					onChange={(e: ISelectInput) => handleSelect(e, "value2")}
					value={state.value2}
					hintText="This is hint text."
					errorMessage=""
					required={true}
					tooltip={"This is a tooltip."}
					addNewSelectOption={true}
					handleAddNewOption={() => alert("Add new option clicked")}
					formSubmitted={formSubmitted}
					isClearable={false}
					menuIsOpen={true}
				/>
				<Dropdown
					id="select-currency"
					label="Multi Select"
					options={options}
					onChange={(e: ISelectInput) => handleSelect(e, "value3")}
					value={state.value3}
					hintText="This is hint text."
					errorMessage=""
					required={true}
					tooltip={"This is a tooltip."}
					handleAddNewOption={() => alert("Add new option clicked")}
					formSubmitted={formSubmitted}
					isMulti={true}
					hideSearchIcon={true}
					isClearable={false}
				/>
				<Dropdown
					id="select-currency"
					label="Multi Select"
					options={options}
					onChange={(e: ISelectInput) => handleSelect(e, "value4")}
					value={state.value4}
					disabled={true}
					placeholder="Disabled"
				/>
				<Dropdown
					id="select-currency"
					label="Select Merchant"
					options={merchantsList}
					onChange={(e: ISelectInput) => handleSelect(e, "value5")}
					value={state.value5}
					hintText="This is hint text."
					errorMessage=""
					required={true}
					tooltip={"This is a tooltip."}
					handleAddNewOption={() => alert("Add new Merchant")}
					formSubmitted={formSubmitted}
					formStyle={{ width: "300px" }}
					type="default"
				/>
				<Dropdown
					id="select-currency"
					label="Icon Leading"
					options={merchantsList}
					onChange={(e: ISelectInput) => handleSelect(e, "value6")}
					value={state.value6}
					formStyle={{ width: "300px" }}
					type="icon-leading"
				/>
				<Dropdown
					id="select-currency"
					label="Avatar Leading"
					options={merchantsList}
					onChange={(e: ISelectInput) => handleSelect(e, "value7")}
					value={state.value7}
					formStyle={{ width: "300px" }}
					type="avatar-leading"
				/>
				<Dropdown
					id="select-currency"
					label="Dot leading"
					options={merchantsList}
					onChange={(e: ISelectInput) => handleSelect(e, "value8")}
					value={state.value8}
					formStyle={{ width: "300px" }}
					type="dot-leading"
				/>
			</div>
		</Section>
	);
};

export default ISelectPopup;
